<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">关联老人</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div style="padding-left: 10px;">
          <el-button type="primary" size="mini" plain @click.native="toggleModalSelectAdd">添加</el-button>

          <div style="clear:both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <el-table ref="tableElderlyRel" class="table" size="mini" :data="tableData" border :height="300">
          <el-table-column label="姓名" prop="name" width="100"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column label="身份证号" prop="idCard"></el-table-column>
          <el-table-column label="地址" prop="homeAddress" ></el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly"
             v-on:closeElderly="showModalGetElderly=false"
             v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyGov";


export default {
  name: 'ElderlyRel',
  props:[],
  data() {
    return {
      showModalGetElderly:false,

      name:'',

      loading: false,

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      businessCode:'',

    }
  },
  components:{Elderly},
  methods: {

    toggleModalSelectAdd(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    closeSelectAdd(){
      this.showModalGetElderly = !this.showModalGetElderly;
    },
    setElderly(row){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/AddElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.businessCode,
          listElderlyCode:[row.elderlyCode],
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$message.success("添加成功");
          this.getList();

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },


    init(businessCode){
      this.businessCode = businessCode;
      this.getList()
    },
    closeSelf() {
      this.$emit("closeElderlyRel");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/PageElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.businessCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;

              this.$nextTick(()=>{
                this.$refs.tableElderlyRel.doLayout();
              });

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },


    handleDelete(index,row){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/DeleteElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          listBusinessElderlyRelCode:[row.businessElderlyRelCode],
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$message.info("删除成功");
          this.getList();
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    }

  }
}


</script>


